import { css } from 'styled-components';

export const Common = css`
  :host,
  :root,
  [data-theme] {
    --chakra-colors-chakra-placeholder-color: #262626 !important;
  }

  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  html,
  body,
  #root {
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
  }

  html,
  body,
  * {
    scrollbar-width: thin;
    scrollbar-color: #c8c8c8 #f3f3f3;
  }

  *::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  *::-webkit-scrollbar-track {
    background: #f3f3f3;
    border-radius: 999px;
  }

  *::-webkit-scrollbar-thumb {
    background: linear-gradient(180deg, #d6d6d6 0%, #bcbcbc 100%);
    border: 2px solid #f3f3f3;
    border-radius: 999px;
  }

  *::-webkit-scrollbar-thumb:hover {
    background: linear-gradient(180deg, #c7c7c7 0%, #ababab 100%);
  }

  html.modal-open-hide-scrollbar,
  body.modal-open-hide-scrollbar {
    overflow: hidden !important;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  html.modal-open-hide-scrollbar::-webkit-scrollbar,
  body.modal-open-hide-scrollbar::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
  }

  a,
  button {
    cursor: pointer;
    transition: all 0.4s ease;
  }
`;
